"use client"
import { parseAsArrayOf, parseAsString, useQueryState } from "nuqs"
import { QUERY_PARAM_KEYS } from "./keys"

export function useCollectionSlugsQueryParam(limit?: number) {
  const [values, setValues] = useQueryState(
    QUERY_PARAM_KEYS.collectionSlugs,
    parseAsArrayOf(parseAsString).withDefault([]),
  )

  const canSelectMore = limit === undefined || values.length < limit

  async function onSelectCollection(collectionSlug: string) {
    const newValues = values.includes(collectionSlug)
      ? values.filter(c => c !== collectionSlug)
      : [...values, collectionSlug]

    if (limit !== undefined && newValues.length > limit) {
      return
    }

    await setValues(newValues.length > 0 ? newValues : null)
  }

  return {
    collectionSlugs: values,
    onSelectCollection,
    canSelectMore,
  }
}
